import { KVBase } from "./kv-base";
import { KVAudio } from "./kv-audio";
import { KVImage } from "./kv-image";

export const Cache = {
  KV: KVBase,
  Audio: KVAudio,
  Image: KVImage,
};
